import { render, staticRenderFns } from "./jskqtj.vue?vue&type=template&id=6ef2397a&scoped=true"
import script from "./jskqtj.vue?vue&type=script&lang=js"
export * from "./jskqtj.vue?vue&type=script&lang=js"
import style0 from "./jskqtj.vue?vue&type=style&index=0&id=6ef2397a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef2397a",
  null
  
)

export default component.exports